import { useQuery, UseQueryResult } from 'react-query';
import { StripeTerminalReaderStatus } from 'types/generated';
import { client } from 'utils/api-client';

export default function useStripeTerminalReaderStatus({
  enabled = false,
}: {
  enabled: boolean;
}): UseQueryResult<{
  data: StripeTerminalReaderStatus;
}> {
  return useQuery(
    ['stripeTerminalReaderStatus'],
    () => client.get('stripe-terminal-readers/reader-status/'),
    { enabled: enabled },
  );
}
